import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _LenthLightCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", d: "m12 2-.354-.354.354-.353.354.353zm.5 15a.5.5 0 0 1-1 0zM7.646 5.646l4-4 .708.708-4 4zm4.708-4 4 4-.708.708-4-4zM12.5 2v15h-1V2z" }),
            React.createElement("path", { fill: "currentColor", d: "m12 22-.354.354.354.353.354-.353zm.5-15a.5.5 0 0 0-1 0zM7.646 18.354l4 4 .708-.708-4-4zm4.708 4 4-4-.708-.708-4 4zM12.5 22V7h-1v15z" })));
}
const LenthLightCustom = forwardRef(_LenthLightCustom);
export { LenthLightCustom };
